import { createContext } from 'react';
import io from 'socket.io-client';
import { API_HOST } from '../../../config';

export const socket = io.connect(API_HOST, { transports: ['websocket'] });
export const SocketContext = createContext(socket);
